import * as Sentry from '@sentry/react';
import { useEffect, useRef } from 'react';

export function useSentryErrorTracker(
  errorCondition: boolean,
  errorMessage: string,
  tag: string,
  extra?: Record<string, any>
) {
  const hasTrackedRef = useRef(false);
  useEffect(() => {
    if (errorCondition && !hasTrackedRef.current) {
      Sentry.captureMessage(`Error in ${tag}: ${errorMessage}`, {
        tags: { section: tag },
        extra,
      });
      hasTrackedRef.current = true;
    }
  }, [errorCondition, errorMessage, tag, extra]);
}
